/**
 * Created by lu on 2018/5/3.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': 'page-notice',
        $html: [{
            'class': 'notice-content',
            $html: [{
                $name:'title',
                'class': 'title',
                $text: nb.bind('noticeText')
            }, {
                $type: require('./NoticeList'),
                $model: 'noticeList'
            }]
        }, {
            'class': 'msg-wrap',
            $html: {
                $type: require('./MsgWrap'),
                $model: 'msgWrap'
            }
        }]
    },
    method:{
        init:function () {
            // var self = this;
            // this.$('title').on('click',function () {
            //     self.getModel().set('messageInfo',new Date());
            // });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/notice/Notice.js
// module id = 37
// module chunks = 0 1 3 4 7 8 9 10 12 13 14 15 16 18 19 21 25 26 27 28 30